import { provideHttpClient, withXhr } from '@angular/common/http';
import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
} from '@angular/core';
import { provideThorBaseUrlResolver } from '@thiememeulenhoff/thor-client';
import { ServicesService } from '../services';
import { API_CONFIG, ApiGatewayConfig } from '../types';

export function provideApiGateway(
  config: ApiGatewayConfig,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideHttpClient(withXhr()),
    provideThorBaseUrlResolver(() => inject(ServicesService).thorServer()),
    {
      provide: API_CONFIG,
      useValue: config,
    },
  ]);
}
